/* eslint-disable no-console */
/* eslint-disable no-undef */
import { filter, isEmpty, every, includes } from 'lodash';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const sessionKey = '.card-selector-data';

const mutations = {
    setItems(state, items) {
        state.items = items;
    },
    setState(state, initState) {
        state = initState;
    },
    updateFilter(state, filter) {
        const { name, isSelected } = filter;
        if(isSelected) {
            if(!state.filters.includes(name)) {
                state.filters.push(name);
            }
        } else {
            state.filters = state.filters.filter(x => x !== name);
        }
        state.selectedIds = getters.selectedItems(state).map(x => x.id);
    },
    itemSelectionChanged(state, selection) {
        const { id, isSelected } = selection;
        if(isSelected) {
            if(!state.selectedIds.includes(id)) {
                state.selectedIds.push(id);
            }
        } else {
            state.selectedIds = state.selectedIds.filter(x => x !== id);
        }
        state.selectedIds = state.selectedIds.filter(id => state.items.some(x => x.id === id));
    },
    initialiseStore(state) {
        if(sessionStorage.getItem(sessionKey)) {
            this.replaceState(
                Object.assign(state, JSON.parse(sessionStorage.getItem(sessionKey)))
            );
        }
    }
};

const getters = {

    availableItems(state) {
        if(state.filters.length === 0) {
            return filter(state.items, x => !isEmpty(x.flags) && x.flags.includes('adults'));
        }
        let items = filter(state.items, x => {
            if(isEmpty(state.filters) || isEmpty(x.flags)) {
                return true;
            }
            return every(state.filters, (filter) => {
                return x.flags.includes(filter);
            });
        });

        return items;
    },
    selectedItems(state) {
        let items = getters.availableItems(state);
        return filter(items, x => includes(state.selectedIds, x.id));
    }
};

const actions = {
    addItem(context, item) {
        context.commit('setItem', item);
    },
    updateFilter(context, filter) {
        context.commit('setFilter', filter);
    }
};

const CardSelectorModule = {
    state: {
        items: [],
        selectedIds: [],
        filters: []
    },
    mutations,
    getters,
    actions
};
export const initStore = () => {
    const store = new Vuex.Store(CardSelectorModule);
    store.subscribe((mutation, state) => {
        sessionStorage.setItem(sessionKey, JSON.stringify(state));
    });
    return store;
};
export default CardSelectorModule;



// WEBPACK FOOTER //
// ./src/app/store/modules/card-selector.js